import React from 'react';
import styled from 'styled-components';

import { SVGIcon } from '@superops/super-icons';

const Wrapper = styled.div`
  background-color: ${(props) =>
    props.bgColor ? props.bgColor : 'transparent'};
  border-radius: 50%;
  height: 35px;
  width: 35px;
  margin: ${(props) => (props.margin ? props.margin : '0 10px 0 0')};
  max-height: 35px;
  max-width: 35px;
`;

const SVGIconWithColorBg = ({ name, bgColor, iconColor, icon, margin }) => {
  return (
    <Wrapper bgColor={bgColor} margin={margin} className="fx actr jctr">
      {icon || <SVGIcon name={name} color={iconColor} />}
    </Wrapper>
  );
};

export default SVGIconWithColorBg;
